export default __webpack_public_path__ + "static/media/ion_close.f00dafa5.svg";